"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadControlItem = void 0;
const complex_utils_1 = require("complex-utils");
class LoadControlItem {
    constructor(initOption) {
        this.offset = initOption.offset;
        this.priority = initOption.priority;
        this.local = initOption.local;
        this.check = initOption.check;
        this.load = initOption.load;
        this.init = initOption.init;
    }
    getLocal() {
        // return getLocalData(this.local) as undefined | D
        return undefined;
    }
    setLocal(value) {
        return (0, complex_utils_1.setLocalData)(this.local, value);
    }
    trigger(init) {
        const initData = this.getLocal();
        if (initData && this.check(initData) && init) {
            // 已加载且当前为初始化加载时，直接set设置值，否则则需要进行获取数据操作
            setTimeout(() => {
                this.trigger();
            }, this.offset);
            this.init(initData);
            return Promise.resolve({ status: 'loaded', data: initData });
        }
        else {
            return new Promise((resolve, reject) => {
                this.load().then((res) => {
                    this.init(res.data);
                    this.setLocal(res.data);
                    resolve(res);
                }).catch(reject);
            });
        }
    }
}
exports.LoadControlItem = LoadControlItem;
class LoadControl {
    constructor() {
        this.data = {};
    }
    pushControl(key, value) {
        const item = new LoadControlItem(value);
        this.data[key] = item;
        return item.trigger(true);
    }
}
exports.default = LoadControl;
